import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./css/infistaking.css";

export default function InfiInstitution() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const sendToContactUs = () => {
    navigate(`${config.baseUrl}contact`);
    window.scrollTo(0, 0)
  };

  return (
    <>
      <section className="infiLaunchpad position-relative pt-5 pb-0">
        <Container className="py-5 position-relative">
          <Row className=" align-items-center">
            <Col lg={10}>
              <div className="">
                <Card className=" bg-transparent border-0">
                  <Card.Body>
                    <div className=" position-relative mb-5">
                      <div className="position-relative d-inline-block text-left">

                        <h1 className="position-relative text-white lh-sm mb-4">
                          <span className="position-relative z-1">
                            INFI for Ecosystem Partners
                            <span className="fw-normal">
                              – Connecting
                              Emerging Blockchain Infrastructure with Traditional Digital
                              Systems.
                            </span>
                          </span>
                          <div className="polygon" style={{ right: "0px" }}>
                            <img
                              src="images/shape/polygon.png"
                              alt=""
                              style={{ width: "208px" }}
                            />
                          </div>
                        </h1>

                        <p className="text-light-grey2 position-relative">
                          Enabling ecosystem participants to access secure, scalable, and
                          efficient blockchain-based tools designed to support
                          decentralised applications, streamline digital asset interactions,
                          and facilitate adaptable data and value flows.
                        </p>
                      </div>

                      <div className="position-relative">
                        <ul className="ps-0 list-unstyled mb-4">
                          <li className="mb-3 text-light-grey2">
                            🔹 Network Participation and Contribution Models{" "}
                          </li>
                          <li className="mb-3 text-light-grey2">
                            🔹 Token Deployment and Engagement Platforms {" "}
                          </li>
                          <li className="mb-3 text-light-grey2">
                            🔹  Enterprise-Grade Blockchain Integration Tools{" "}
                          </li>
                         
                        </ul>
                        {/* <Button
                          variant="white-gradient"
                          className="me-3 px-5 rounded-5 text-uppercase"
                          onClick={sendToContactUs}
                        >
                          Contact Us&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7921 1.08813L22.6729 9.21992M22.6729 9.21992L15.7921 17.3517M22.6729 9.21992L1.3269 9.21992"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
